// NODE_ENV es 'production' tanto en staging como en prod (ambos son builds),
// asi que para esconder features solo en prod hay que mirar el hostname.
// trycloudflare.com y devtunnels.ms son tunnels temporales que usamos para QA
// mobile / remoto: nunca son prod real, deben tratarse como no-prod para que
// aparezca el toggle de Vista QA y se honre localStorage.__force_inbox.
const NON_PRODUCTION_HOSTNAMES = ['localhost', 'staging', 'trycloudflare', 'devtunnels']

export function isNonProductionHost() {
    return NON_PRODUCTION_HOSTNAMES.some((h) => window.location.hostname.includes(h))
}
